import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { Row, Col } from 'antd';

import { HeadSEO } from 'components/base';
import ProductPurchaseCol from 'components/productPurchaseCol';

import { getLang, getIsMobile, getRealID } from 'utils/helpers';
import { DEFAULT_SEO } from 'utils/constants/seo';

const ProductSheetDim = ({
  productSheet, locale, market, metatags,
}) => {
  const isMobile = getIsMobile();
  const router = useRouter();
  const { query } = router;
  const { target, product } = query;

  const averageRate = productSheet.rate ? Math.round(productSheet.rate * 10) / 10 : null;
  const hasReviews = !productSheet.emptyReviews;
  const { code } = productSheet;
  const lang = getLang(locale);

  const targetRealID = getRealID('target', target);
  const familyRealID = getRealID('product', product);

  const gtmProps = {
    target, product, productSheet, targetRealID, familyRealID,
  };

  useEffect(() => {
    if (window?.customDIM) {
      const emptyFunc = () => undefined;
      const camperONEConfig = productSheet.camperone.jsonConfig.piezas;
      const [ firstFragment ] = code.split('-');
      const configObject = {
        piezas: camperONEConfig,
        id: firstFragment,
      };
      window.customDIM.install('dimContainer', configObject, lang, emptyFunc, emptyFunc);
    }
  }, []);

  const headScripts = [
    <script key="customDim" type="text/javascript" src={'https://dimtech.es/CustomDIM/Camper/testIFrame/js/customDIM.js'}></script>,
  ];

  return (
    <div>
      <HeadSEO
        title={metatags?.titlePage || DEFAULT_SEO.title}
        description={metatags?.metaDescription || DEFAULT_SEO.description}
        gtmProps={gtmProps}
        scripts={headScripts}
        pageName="detail"
      />
      <Row>
        <Col xs={24} md={24} lg={16}>
          <div id="dimContainer"></div>
        </Col>
        <ProductPurchaseCol
          averageRate={averageRate}
          hasReviews={hasReviews}
          locale={locale}
          market={market}
          product={product}
          productSheet={productSheet}
          isCamperOne
          isRoku={false}
          isFullScreen={false}
          target={target}
          onCustomize={() => undefined}
          isMobile={isMobile}
          columnSizes={{
            xs: 24,
            md: 24,
            lg: 8,
          }}
        />
      </Row>
    </div>
  );
};

ProductSheetDim.propTypes = {
  productSheet: PropTypes.object,
  datetime: PropTypes.string,
  uuid: PropTypes.string,
  // to-do [1]: definir bien las keys del objeto, que esperan, si son opcionales, etc...
  locale: PropTypes.string,
  market: PropTypes.string,
  metatags: PropTypes.object,
};

export default ProductSheetDim;
